import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, unref as _unref, withModifiers as _withModifiers, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-013c8382"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main_sbxx" }
const _hoisted_2 = { style: {"width":"15%","height":"100%"} }
const _hoisted_3 = { class: "flexBetween left" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "角色列表", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode("+")
const _hoisted_6 = { class: "list_search" }
const _hoisted_7 = { class: "search_header" }
const _hoisted_8 = {
  class: "flexWrap",
  style: {"width":"80%"}
}
const _hoisted_9 = { class: "header_nr flexAlign" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "姓名：", -1))
const _hoisted_11 = {
  class: "header_twonr",
  style: {"margin-top":"20px"}
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("添加")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("权限配置")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_16 = {
  class: "flexEnd",
  style: {"padding":"20px"}
}
const _hoisted_17 = { class: "my-header" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "添加角色", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_20 = { class: "flexCenter" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("提 交")
const _hoisted_22 = { class: "my-header" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "编辑", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_25 = { class: "flexCenter" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("提 交")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("删 除")
const _hoisted_28 = { class: "my-header" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "角色配置人员", -1))
const _hoisted_30 = { class: "my-header" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "权限配置", -1))

import { ref,onMounted,nextTick } from 'vue';
	import { CirclePlus,Search } from '@element-plus/icons-vue';
	import {
        requestEditConfig,
        requestGetAllConfig,
        requestGetAllConfigPid0,
        requestEditValue,
        requestConfigDel,
        requestConfigList2,
        requestConfigDel1
    } from '@/api/configApi';
	import {
		requesteditrolename,
		requestdelrole,
		requestrolelist,
		requestroleinfo,
		requestsaverolepermissions,
		requestqueryuserbyrole,
		requestedituserfromrole,
		requestdeleteuserfromrole
    } from '@/api/permissionsApi';
	import { ElMessage } from 'element-plus';
    import Ztree from '@/components/Ztree'
    import Excel from '@/components/Excel'
    
export default /*#__PURE__*/_defineComponent({
  name: 'Permissions',
  setup(__props) {

    const tableData1 = ref<any[]>([])
    const addleftShow = ref(false)
    const exceladdShow = ref<boolean>(false)
    const excelShow= ref<boolean>(false)
    const editpermissionShow = ref<boolean>(false)
    const permissionShow= ref<boolean>(false)
    const roleid = ref("")
    const form = ref<any>({
        rolename:'',
        id:''
    })
    const sb = ref({
        name:'',
        id:0
    })
    const editShow = ref(false)
    const tableData = ref<any[]>([])
	const loading = ref<boolean>(false)
    const pageIndex = ref<number>(1)
	const pageSize = ref<number>(10)
	const pages = ref({
		totalCount:0
	})
	const search = ref({
		name:''
	})
    const pid0 = ref<any[]>([])
    const listId = ref(0)
    const addrightShow = ref(false)
    const cp = ref({
        value:'',
        field0:''
    })
    const cpid = ref(0)
    onMounted(()=>{
        pid0List();
    })
    const addrole = () => {
        sbcz();
        addleftShow.value = true
    }
   const sbcz = () => {
        form.value = {
            rolename:''
        }
    }
    const addrolesubmit = () => {
        if(form.value.rolename==""){
    		ElMessage.error("请输入角色名称");
    		return ;
    	}
        requesteditrolename({
        	rolename:form.value.rolename
        }).then((res:any)=>{
			if(res.status === 1){
			    ElMessage({
			        message: "添加成功",
			        type: 'success',
			        duration: 500
			    });
				setTimeout(()=>{
					addleftShow.value = false
                    pid0List();
				},500)
			}
		})
    }
    const sbppCellClick = (row:any) => {
        sb.value = {
            id:row.id,
            rolename:row.value
        }
        editShow.value = true
    }
    const ppmcdelsubmit = () => {
        requestdelrole({
            id:sb.value.id
        }).then((res:any)=>{
			if(res.status === 1){
			    ElMessage({
			        message: "删除成功",
			        type: 'success',
			        duration: 500
			    });
				setTimeout(()=>{
					editShow.value = false
                    pid0List();
				},500)
			}
		})
    }
    const ppmcsubmit = () => {
        if(sb.value.name==""){
    		ElMessage.error("请输入角色名称");
    		return;
    	}
        requesteditrolename({
        	id:sb.value.id,
        	rolename:sb.value.rolename
        }).then((res:any)=>{
			if(res.status === 1){
			    ElMessage({
			        message: "编辑成功",
			        type: 'success',
			        duration: 500
			    });
				setTimeout(()=>{
					editShow.value = false
                    pid0List();
				},500)
			}
		})
    }
 
    const pid0List = () => {
        tableData1.value = []
        requestrolelist({
            type:"设备品牌列表"
        }).then((res:any)=>{
            if(res.status === 1){
                pid0.value = res.datalist
                tableData1.value = res.datalist.map((val:any)=>{
                    return {id:val.id,value:val.rolename,children:[]}
                })
                ppList();
            }
        })
    }
 
    const ppList = () => {
        requestGetAllConfig({}).then((res:any)=>{
            if(res.status === 1){
                tableData1.value.forEach((v:any)=>{
                    res.datalist.forEach((val:any)=>{
                        if(v.id == val.pid){
                            v.children.push({id:val.id,value:val.rolename})
                        }
                    })
                })
            }
        })
    }
    const searchList = () =>{
		pageIndex.value = 1
		getList();
	}
    const sbppClick = (row:any) => {
        listId.value = row.id
        roleid.value =row.id
        getList();
    }
    const getList = () => {
        requestqueryuserbyrole({
            pageIndex:pageIndex.value,
			pageSize:pageSize.value,
            name:search.value.name,
            roleid:listId.value
        }).then((res:any)=>{
			tableData.value = res.data
			pages.value.totalCount = res.totalCount
			loading.value = false
		})
    }
    
    const addForm = () => {
        if(listId.value == 0){
            ElMessage.error("请先选择左侧角色");
    		return ;
        }
        excelsx();
        exceladdShow.value = true
    }
    const EditPermissonForm = ()=>{
        if(listId.value == 0){
            ElMessage.error("请先选择左侧角色");
            return ;
        }
        permissionsx();
        editpermissionShow.value = true
    }
    const listxqconfig = (row:any) => {
        cp.value = {
            value:row.cell.value,
            field0:row.cell.field0
        }
        cpid.value = row.cell.id
        addrightShow.value = true
    }
    const listdelconfig = (row:any) => {
        requestdeleteuserfromrole({
            roleid:row.cell.roleid,
            userid:row.cell.id,
        }).then((res:any)=>{
			if(res.status === 1){
			    ElMessage({
			        message: "删除成功",
			        type: 'success',
			        duration: 500
			    });
				setTimeout(()=>{
                    searchList();
				},500)
			}
		})
    }
    const excelsx = () =>{
        excelShow.value = false
        nextTick(()=>{
            excelShow.value = true
        })
    }
    const excelcancel = () => {
        exceladdShow.value = false
        getList();
    }
    ////////
    const permissionsx = () =>{
        permissionShow.value = false
        nextTick(()=>{
            permissionShow.value = true
        })
    }
    const permissioncancel = () => {
        editpermissionShow.value = false
    }
   
    ///////
    const handleSizeChange = (val: number) =>{
		pageSize.value = val
		getList()
	}
	const handleCurrentChange = (val: number) =>{
		pageIndex.value = val
		getList()
	}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_Close = _resolveComponent("Close")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_table, {
        onCellClick: sbppClick,
        onCellDblclick: sbppCellClick,
        data: tableData1.value,
        "header-cell-style": {color:'#000',backgroundColor:'#fafbfd'},
        border: "",
        "row-key": "id",
        "highlight-current-row": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: "",
            prop: "value"
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createVNode(_component_el_button, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (addrole())),
                  type: "primary",
                  size: "small",
                  style: {"width":"20px","height":"20px","font-size":"22px"}
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    _createElementVNode("div", {
      style: _normalizeStyle([{"width":"84%","border":"1px solid #ebeef5"}, tableData.value.length<10?'height:38rem;':''])
    }, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_component_el_input, {
                size: "small",
                modelValue: search.value.name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search.value.name) = $event)),
                style: {width:'150px'},
                onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (searchList()), ["enter","native"]))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_el_button, {
              plain: "",
              type: "primary",
              size: "small",
              icon: _unref(Search),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (searchList()))
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            }, 8, ["icon"]),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (addForm())),
              size: "small",
              icon: _unref(CirclePlus)
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            }, 8, ["icon"]),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (EditPermissonForm())),
              size: "small",
              icon: _unref(CirclePlus)
            }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            }, 8, ["icon"])
          ])
        ])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: tableData.value,
        "header-cell-style": {color:'#000',backgroundColor:'#fafbfd'}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            type: "index",
            width: "80",
            label: "序号",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "cell.code",
            label: "编号",
            width: "200"
          }),
          _createVNode(_component_el_table_column, {
            prop: "cell.name",
            label: "姓名",
            width: "200"
          }),
          _createVNode(_component_el_table_column, {
            prop: "cell.tel",
            label: "手机号",
            width: "200"
          }),
          _createVNode(_component_el_table_column, {
            prop: "cell.rolelist",
            label: "身份",
            width: "150"
          }),
          _createVNode(_component_el_table_column, {
            prop: "cell.area",
            label: "区域",
            width: "150"
          }),
          _createVNode(_component_el_table_column, { label: "操作" }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                link: "",
                type: "danger",
                size: "small",
                onClick: _withModifiers(($event: any) => (listdelconfig(scope.row)), ["stop"])
              }, {
                default: _withCtx(() => [
                  _hoisted_15
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, loading.value]
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_el_pagination, {
          onSizeChange: handleSizeChange,
          onCurrentChange: handleCurrentChange,
          currentPage: pageIndex.value,
          "onUpdate:currentPage": _cache[6] || (_cache[6] = ($event: any) => ((pageIndex).value = $event)),
          "page-sizes": [10, 20, 30],
          "page-size": pageSize.value,
          "onUpdate:page-size": _cache[7] || (_cache[7] = ($event: any) => ((pageSize).value = $event)),
          layout: "total, sizes, prev, pager, next, jumper",
          total: pages.value.totalCount
        }, null, 8, ["currentPage", "page-size", "total"])
      ])
    ], 4),
    _createVNode(_component_el_dialog, {
      modelValue: addleftShow.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((addleftShow).value = $event)),
      "show-close": false,
      "close-on-click-modal": false
    }, {
      header: _withCtx(({ close, titleId, titleClass }) => [
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createVNode(_component_el_icon, {
            class: "delicon",
            onClick: close
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Close)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          style: {width:'90%'},
          "label-width": "100px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "角色名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.value.rolename,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.value.rolename) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _hoisted_19,
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_el_button, {
            onClick: _cache[9] || (_cache[9] = ($event: any) => (addrolesubmit())),
            type: "primary",
            round: ""
          }, {
            default: _withCtx(() => [
              _hoisted_21
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: editShow.value,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((editShow).value = $event)),
      "show-close": false,
      "close-on-click-modal": false
    }, {
      header: _withCtx(({ close, titleId, titleClass }) => [
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _createVNode(_component_el_icon, {
            class: "delicon",
            onClick: close
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Close)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          style: {width:'80%'},
          "label-width": "100px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "角色名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: sb.value.rolename,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((sb.value.rolename) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _hoisted_24,
            _createElementVNode("div", _hoisted_25, [
              _createVNode(_component_el_button, {
                onClick: _cache[12] || (_cache[12] = ($event: any) => (ppmcsubmit())),
                type: "primary",
                round: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_26
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                onClick: _cache[13] || (_cache[13] = ($event: any) => (ppmcdelsubmit())),
                type: "danger",
                round: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_27
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "角色配置人员",
      modelValue: exceladdShow.value,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((exceladdShow).value = $event)),
      "show-close": false
    }, {
      header: _withCtx(({ close, titleId, titleClass }) => [
        _createElementVNode("div", _hoisted_28, [
          _hoisted_29,
          _createVNode(_component_el_icon, {
            class: "delicon",
            onClick: _cache[15] || (_cache[15] = ($event: any) => (exceladdShow.value=false))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Close)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (excelShow.value)
          ? (_openBlock(), _createBlock(_unref(Ztree), {
              key: 0,
              onCancel: _cache[16] || (_cache[16] = ($event: any) => (excelcancel())),
              roleid: roleid.value,
              lb: "部门人员",
              needInt: "true"
            }, null, 8, ["roleid"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "权限配置",
      modelValue: editpermissionShow.value,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((editpermissionShow).value = $event)),
      "show-close": false
    }, {
      header: _withCtx(({ close, titleId, titleClass }) => [
        _createElementVNode("div", _hoisted_30, [
          _hoisted_31,
          _createVNode(_component_el_icon, {
            class: "delicon",
            onClick: _cache[18] || (_cache[18] = ($event: any) => (editpermissionShow.value=false))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Close)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (permissionShow.value)
          ? (_openBlock(), _createBlock(_unref(Ztree), {
              key: 0,
              onCancel: _cache[19] || (_cache[19] = ($event: any) => (permissioncancel())),
              roleid: roleid.value,
              lb: "功能权限",
              needInt: "false"
            }, null, 8, ["roleid"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})